export default {
  items: [
    /*{
      title: true,
      name: "Happy Quest",
      wrapper: {
        element: "",
        attributes: {}
      }
    },*/
    {
      name: "Tableau de bord",
      url: "/",
      icon: "fa fa-dashboard",
      badge: {
        variant: "info"
      }
    },
    /*{
      name: "Statistiques d'usage",
      url: "/StatistiquesUsages",
      icon: "fa fa-bar-chart"
    },*/
    {
      name: "Labels",
      url: "/tags",
      icon: "fa fa-tags"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js